module.exports = __webpack_public_path__ + "static/image/luhu.png?34190b48a7ac99b5ab95041abe4dfb5c";